import {HttpModelConverter} from '../../../../converter/httpModel.converter';
import {QueryParams} from '@ngrx/data';
import {Observable} from 'rxjs';
import {Page} from '../../../../../../shared/model/core/page.model';
import {AbstractDataServiceV2} from '../abstractDataServiceV2';
import {DtoModel} from '../../../../../common/entity/dto/dto.model';

export abstract class AbstractDataServiceAdapter<StoredEntity extends DtoModel, Entity, Converter extends HttpModelConverter<Entity>> {

    readonly dataService: AbstractDataServiceV2<StoredEntity, any>;
    readonly converter: HttpModelConverter<Entity>;

    protected constructor(dataService: AbstractDataServiceV2<StoredEntity, any>, converter: HttpModelConverter<Entity>) {
        this.dataService = dataService;
        this.converter = converter;
    }


    getMultipleWithQuery(path: string, params?: string | QueryParams): Observable<Page<Entity>> {
        return this.dataService.getMultipleWithQuery(this.converter, path, params);
    }

    getOneWithQuery(path: string, params?: string | QueryParams): Observable<Entity> {
        return this.dataService.getOneWithQuery(this.converter, path, params);

    }


    executeUpdate(id: number | string, payload: any, path?: string): Observable<StoredEntity> {
        return this.dataService.executeUpdate(id, payload, path);
    }

    executeCreate(payload: any, path?: string): Observable<StoredEntity> {
        return this.dataService.executeCreate(payload, path);
    }

    executeDeleteWithQueryParams(id: number | string, queryParams: string): Observable<void> {
        return this.dataService.executeDeleteWithQueryParams(id, queryParams);
    }

    abstract isDtoSummary(): boolean;

    abstract buildEntityFromStoreEntity(storedEntity: StoredEntity): Entity;

    abstract buildStoredEntityEntity(entity: Entity): StoredEntity;

    abstract newStoredEntityInstance(): StoredEntity;
}
